import React from 'react';

export interface ReportProps {}

const Report: React.FC<ReportProps> = () => {
  return null;
};

export default Report;
